export function formatUtcOffset(offset: string): string {
    if (offset === 'UTC±0') {
        return offset
    }

    const match = offset.match(/^UTC([+-])(\d{1,2})(?::(\d{2}))?$/)

    if (!match) return offset

    const [, sign, hours, minutes] = match

    // If minutes exist and are not "00", keep full format
    if (minutes && minutes !== '00') {
        return `UTC${sign}${hours}:${minutes}`
    }

    const normalizedHours = String(Number(hours)) // removes leading zeros
    return `UTC${sign}${normalizedHours}`
}
